import { useEffect, useState } from "react";
import { Card, Row, Col, Table, Form } from "react-bootstrap";
import Pagination from "components/Util/Pagination";
import moment from "moment";
import GenericModal from "../components/Modal/GenericModal";
import { BarLoader } from "react-spinners";
const {
  getGeneralInfo,
  getSpend,
  getCollect,
  getPurchase,
  giveToken,
} = require("./../services/factory.service");

export default function Factory(props) {
  const [consumerId, setConsumerId] = useState("");
  const [general, setGeneral] = useState({ all: 0, used: 0, unused: 0 });
  const [spendlist, setSpendlist] = useState([]);
  const [collectlist, setCollectlist] = useState([]);
  const [purchaselist, setPurchaselist] = useState([]);

  const [spendPagination, setSpendPagination] = useState();
  const [collectPagination, setCollectPagination] = useState();
  const [purchasePagination, setPurchasePagination] = useState();
  const [state, setState] = useState({
    note: "",
    qty: 0,
  });
  const [level, setLevel] = useState("v4");

  const [loading, setLoading] = useState(false);

  useEffect(async () => {
    if (props.consumer) {
      setConsumerId(props.consumer._id);

      General();
      spend();
      collect();
      // purchase();
      setState((prevState) => {
        return {
          ...prevState,
          name: props?.currentUser?.sub,
          consumerId: props.consumer._id,
        };
      });
    }
  }, [props?.consumer, level]);

  useEffect(() => {
    if (new Date() > new Date("2025-09-15")) {
      setLevel("v4");
    }
  }, []);

  const General = async () => {
    try {
      setLoading(true);
      const result = await getGeneralInfo(props.consumer._id, level);

      setGeneral(result.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const spend = async (offset = 0, limit = 10) => {
    try {
      const res = await getSpend(props.consumer._id, offset, limit, level);

      setSpendlist(res.data?.list);
      setSpendPagination(res.data?.pagination);
    } catch (err) {
      console.log(err);
    }
  };
  const collect = async (offset = 0, limit = 10) => {
    try {
      const res = await getCollect(props.consumer._id, offset, limit, level);
      setCollectlist(res.data?.list);
      setCollectPagination(res.data?.pagination);
    } catch (err) {
      console.log(err);
    }
  };
  const purchase = async (offset = 0, limit = 10) => {
    try {
      const res = await getPurchase(props.consumer._id, offset, limit, level);
      setPurchaselist(res.data?.list);
      setPurchasePagination(res.data?.pagination);
    } catch (err) {
      console.log(err);
    }
  };
  const give_token = async () => {
    try {
      const res = await giveToken(state);
      props.notify("tr", "success", `${res.data.status}`);
      General();
      setState((prevState) => {
        return { ...prevState, qty: 0, note: "" };
      });
    } catch (err) {
      props.notify("tr", "danger", "Эрх олгоход алдаа гарлаа");
      console.log(err);
    }
  };
  return (
    <>
      <Row>
        <Col md="6">
          <Card className="striped-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Хэрэглэгч эрх</Card.Title>
            </Card.Header>
            <Col md="4">
              <Form.Group style={{ marginRight: "12px", marginTop: "18px" }}>
                <Form.Control
                  as="select"
                  value={level}
                  name="version"
                  className="form-control"
                  onChange={async (e) => {
                    setLevel(e.target.value);
                  }}
                >
                  {[
                    {
                      name: "Үе 1",
                      value: "v3",
                    },
                    {
                      name: "Үе 2",
                      value: "v4",
                    },
                  ].map((lev, i) => (
                    <option key={i} value={lev.value}>
                      {lev.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Card.Body className="table-full-width table-responsive px-0">
              <Col md="12">
                {loading ? (
                  <BarLoader />
                ) : (
                  <Table
                    className="table-hover"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th className="border-0">Нийт эрх</th>
                        <th className="border-0">Ашигласан эрх</th>
                        <th className="border-0">Ашиглаагүй эрх</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{general?.all}</td>
                        <td>{general?.used}</td>
                        <td>{general?.unused}</td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </Col>
            </Card.Body>
          </Card>
        </Col>
        <Col md="6">
          <Card className="striped-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Эрх нөхөн олгох</Card.Title>
            </Card.Header>
            <Card.Body>
              <Form>
                <Row>
                  <Col sm="6">
                    <Form.Group controlId="formBasicPassword">
                      <Form.Label>Олгох эрхийн тоо</Form.Label>
                      <Form.Control
                        type="number"
                        name={"count"}
                        value={state.qty}
                        onChange={(e) => {
                          setState((prevState) => {
                            return {
                              ...prevState,
                              qty: e.target.value,
                            };
                          });
                        }}
                      />
                      <Form.Label>Тайлбар</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Тайлбар"
                        value={state.note}
                        name="note"
                        onChange={(e) => {
                          setState((prevState) => {
                            return { ...prevState, note: e.target.value };
                          });
                        }}
                        as="textarea"
                        rows={3}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <GenericModal
                      sm="3"
                      onClick={async () => {
                        if (!props.consumer) {
                          props.notify("tr", "danger", "Хэрэглэгч оруулна уу!");
                          return;
                        }
                        if (!state.qty) {
                          props.notify("tr", "danger", "Эрхийг тоо 0 байна!");
                          return;
                        }
                        await give_token();
                      }}
                      params={{}}
                      action={"Олгох"}
                      title={`Та үйлдэл хийхдээ итгэлтэй байна уу.`}
                      body={`Та ${props?.consumer?.mobile} дугаарт ${state.qty} эрх олгох гэж байна.`}
                      type={"button"}
                    />
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* spend */}
      <Row>
        <Col md="8">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Эрх Зарцуулалт</Card.Title>
            </Card.Header>
            <Card.Body className="table-full-width table-responsive px-0">
              <Table
                className="table-hover"
                style={{
                  fontSize: "12px",
                }}
              >
                <thead>
                  <tr>
                    <th className="border-0">Эрх Үүссэн огноо</th>
                    <th className="border-0">Тоглосон огноо</th>
                    <th className="border-0">Шагнал</th>
                    <th className="border-0">Суваг</th>
                  </tr>
                </thead>
                <tbody>
                  {spendlist?.length > 0
                    ? spendlist?.map((play, ind) => (
                        <tr key={ind}>
                          <td key={ind}>
                            {play?.created_at
                              ? moment
                                  .utc(play?.created_at.toString())
                                  .format("YYYY-MM-DD HH:mm:ss")
                              : ""}
                          </td>
                          <td>
                            {play?.played_date
                              ? moment
                                  .utc(play?.played_date)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              : ""}
                          </td>
                          <td>{play?.game_V4[0]?.prize?.name}</td>
                          <td>{play?.game_V4[0]?.prize?.prize_type}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </Table>
            </Card.Body>
            <Pagination
              pagination={spendPagination}
              onChange={(offset, limit) => {
                spend(offset, limit);
              }}
            />
          </Card>
        </Col>
      </Row>
      {/* collect */}
      <Row>
        <Col md="8">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Эрх Цуглуулалт</Card.Title>
            </Card.Header>
            <Card.Body className="table-full-width table-responsive px-0">
              <Table
                className="table-hover"
                style={{
                  fontSize: "12px",
                }}
              >
                <thead>
                  <tr>
                    <th className="border-0">Билл</th>
                    <th className="border-0">Үүссэн огноо</th>
                    <th className="border-0">Тоо</th>
                    <th className="border-0">Суваг</th>
                    <th className="border-0">Дэлгэрэнгүй</th>
                  </tr>
                </thead>
                <tbody>
                  {collectlist?.length > 0
                    ? collectlist?.map((el, ind) => (
                        <tr key={ind}>
                          <td>{el?.billId}</td>
                          <td>
                            {moment
                              .utc(el?.created_at.toString())
                              .format("YYYY-MM-DD HH:mm:ss")}
                          </td>
                          <td>{el?.count}</td>
                          <td>{el?.token}</td>
                          <td>{el?.description}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </Table>
            </Card.Body>
            <Pagination pagination={collectPagination} onChange={collect} />
          </Card>
        </Col>
      </Row>
    </>
  );
}
